module.exports = __webpack_public_path__ + "img/ZJ5161.40755b0a.png";